// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.futuristic-text {
  font-family: "Orbitron", sans-serif;
  color: #fff !important;
  text-shadow: 0 0 5px rgba(255, 255, 255, 0.6),
    0 0 10px rgba(255, 255, 255, 0.6);
}

.futuristic-card {
  min-height: 300px;
  background-color: #050A30 !important;
  color: #fff !important;
  border: 1px solid #444 !important;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.futuristic-card:hover {
  transform: scale(1.05);
  box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.3);
}

.futuristic-card-title {
  font-size: 1.6rem;
  color: #fff !important;
  display: flex;
  align-items: center;
  margin-top: "10px";
}

.futuristic-card-subtitle {
  font-size: 1.2rem;
  color: #ffffff !important;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}

.real-time-container {
  margin-top: 20px;
}

.card {
  background-color: #050a30 !important;
  color: #fff !important;
  border: 2px solid #555 !important;
}

.card-body {
  padding: 1.25rem;
}

.card-title,
.card-subtitle,
.card-text {
  color: #fff !important;
}

.card-subtitle {
  color: #aaa !important;
}

.card-text {
  color: #bbb !important;
}

.text-warning {
  color: #ffd700 !important;
}

.text-danger {
  color: #f44336 !important;
}

.text-muted {
  color: #ffffff !important;
}

.futuristic-card-text {
  font-size: 1.2rem;
  color: #ccc; /* Gris clair */
  display: flex;
  align-items: center;
  margin-top: "20px";
}

.animated-data {
  font-size: 1.2rem;
  color: #0088ff;
  font-weight: bold;
  display: flex;
  align-items: center;
  margin-left: 4px;
}

.animated-data-icon {
  margin-right: 8px;
  font-size: 1.7rem;
  animation: bounce 1s infinite;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-4px);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}

.futuristic-title {
  font-size: 3rem;
  font-weight: 700;
  color: #ffffff;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 3px;
  background: linear-gradient(
    45deg,
    #0088ff,
    #050a30,
    #808080
  );
  -webkit-background-clip: text;
  background-clip: text;
  animation: glow 1.5s ease-in-out infinite alternate;
  padding: 10px 0;
}

@keyframes glow {
  0% {
    text-shadow: 0 0 5px #0088ff, 0 0 10px #0088ff, 0 0 15px #0088ff,
      0 0 20px #050a30, 0 0 25px #050a30;
  }
  50% {
    text-shadow: 0 0 10px #0088ff, 0 0 20px #0088ff, 0 0 30px #050a30,
      0 0 40px #050a30;
  }
  100% {
    text-shadow: 0 0 15px #0088ff, 0 0 25px #0088ff, 0 0 40px #050a30,
      0 0 50px #050a30;
  }
}

.futuristic-title:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease-in-out;
}

.futuristic-title::after {
  content: " ";
  display: block;
  width: 50%;
  height: 2px;
  background: #0088ff;
  margin: 20px auto;
  animation: slide 1.5s infinite;
}

@keyframes slide {
  0% {
    transform: scaleX(0);
    opacity: 0;
  }
  50% {
    transform: scaleX(1);
    opacity: 1;
  }
  100% {
    transform: scaleX(0);
    opacity: 0;
  }
}

.online-card {
  /* border-left: 6px solid #28a745 !important; */
  background-color: #050A30 !important;
  animation: pulseOnline 1.5s infinite;
}

.offline-card {
  background-color: #1c1f3a !important;
  opacity: 1;
  /* border: 1px dashed #888 !important; */
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
}

.status-online {
  background-color: #00c853;
  color: #fff;
}

.status-offline {
  background-color: #d32f2f;
  color: #fff;
}


.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: bold;
  text-transform: uppercase;
}

.status-online {
  background-color: #00c853;
  color: #fff;
}

.status-offline {
  background-color: #d32f2f;
  color: #fff;
}


@keyframes pulseOnline {
  0% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);
  }
}

.offline-info {
  flex-grow: 1;
  color: #b0b0b0;
  padding: 20px 10px;
}

.offline-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #e57373;
}

.offline-subtitle {
  font-size: 0.9rem;
  font-style: italic;
  color: #9e9e9e;
}

.chart-legends {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 0.9rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.legend-item.hidden {
  text-decoration: line-through;
  opacity: 0.5;
}

.legend-icon {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 6px;
}

@keyframes rotate {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animated-icon {
  display: inline-block;
  animation: rotate 2s linear infinite;
}

@keyframes dots {
  0% { content: " "; }
  33% { content: "."; }
  66% { content: ".."; }
  100% { content: "..."; }
}

.animated-dots::after {
  content: "...";
  animation: dots 1.5s infinite;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/usageNowPage.css"],"names":[],"mappings":"AAAA;EACE,mCAAmC;EACnC,sBAAsB;EACtB;qCACmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;EACjC,mEAAmE;AACrE;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW,EAAE,eAAe;EAC5B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB;;;;;GAKC;EACD,6BAA6B;EAC7B,qBAAqB;EACrB,mDAAmD;EACnD,eAAe;AACjB;;AAEA;EACE;IACE;wCACoC;EACtC;EACA;IACE;sBACkB;EACpB;EACA;IACE;sBACkB;EACpB;AACF;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;;AAGA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,YAAY,EAAE;EACpB,MAAM,aAAa,EAAE;EACrB,OAAO,cAAc,EAAE;AACzB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B","sourcesContent":[".futuristic-text {\n  font-family: \"Orbitron\", sans-serif;\n  color: #fff !important;\n  text-shadow: 0 0 5px rgba(255, 255, 255, 0.6),\n    0 0 10px rgba(255, 255, 255, 0.6);\n}\n\n.futuristic-card {\n  min-height: 300px;\n  background-color: #050A30 !important;\n  color: #fff !important;\n  border: 1px solid #444 !important;\n  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n}\n\n.futuristic-card:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.3);\n}\n\n.futuristic-card-title {\n  font-size: 1.6rem;\n  color: #fff !important;\n  display: flex;\n  align-items: center;\n  margin-top: \"10px\";\n}\n\n.futuristic-card-subtitle {\n  font-size: 1.2rem;\n  color: #ffffff !important;\n}\n\n@keyframes blink {\n  50% {\n    opacity: 0;\n  }\n}\n\n.real-time-container {\n  margin-top: 20px;\n}\n\n.card {\n  background-color: #050a30 !important;\n  color: #fff !important;\n  border: 2px solid #555 !important;\n}\n\n.card-body {\n  padding: 1.25rem;\n}\n\n.card-title,\n.card-subtitle,\n.card-text {\n  color: #fff !important;\n}\n\n.card-subtitle {\n  color: #aaa !important;\n}\n\n.card-text {\n  color: #bbb !important;\n}\n\n.text-warning {\n  color: #ffd700 !important;\n}\n\n.text-danger {\n  color: #f44336 !important;\n}\n\n.text-muted {\n  color: #ffffff !important;\n}\n\n.futuristic-card-text {\n  font-size: 1.2rem;\n  color: #ccc; /* Gris clair */\n  display: flex;\n  align-items: center;\n  margin-top: \"20px\";\n}\n\n.animated-data {\n  font-size: 1.2rem;\n  color: #0088ff;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  margin-left: 4px;\n}\n\n.animated-data-icon {\n  margin-right: 8px;\n  font-size: 1.7rem;\n  animation: bounce 1s infinite;\n}\n\n@keyframes bounce {\n  0% {\n    transform: translateY(0);\n  }\n  25% {\n    transform: translateY(-4px);\n  }\n  50% {\n    transform: translateY(0);\n  }\n  75% {\n    transform: translateY(-4px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.futuristic-title {\n  font-size: 3rem;\n  font-weight: 700;\n  color: #ffffff;\n  text-align: center;\n  text-transform: uppercase;\n  letter-spacing: 3px;\n  background: linear-gradient(\n    45deg,\n    #0088ff,\n    #050a30,\n    #808080\n  );\n  -webkit-background-clip: text;\n  background-clip: text;\n  animation: glow 1.5s ease-in-out infinite alternate;\n  padding: 10px 0;\n}\n\n@keyframes glow {\n  0% {\n    text-shadow: 0 0 5px #0088ff, 0 0 10px #0088ff, 0 0 15px #0088ff,\n      0 0 20px #050a30, 0 0 25px #050a30;\n  }\n  50% {\n    text-shadow: 0 0 10px #0088ff, 0 0 20px #0088ff, 0 0 30px #050a30,\n      0 0 40px #050a30;\n  }\n  100% {\n    text-shadow: 0 0 15px #0088ff, 0 0 25px #0088ff, 0 0 40px #050a30,\n      0 0 50px #050a30;\n  }\n}\n\n.futuristic-title:hover {\n  transform: scale(1.1);\n  transition: transform 0.3s ease-in-out;\n}\n\n.futuristic-title::after {\n  content: \" \";\n  display: block;\n  width: 50%;\n  height: 2px;\n  background: #0088ff;\n  margin: 20px auto;\n  animation: slide 1.5s infinite;\n}\n\n@keyframes slide {\n  0% {\n    transform: scaleX(0);\n    opacity: 0;\n  }\n  50% {\n    transform: scaleX(1);\n    opacity: 1;\n  }\n  100% {\n    transform: scaleX(0);\n    opacity: 0;\n  }\n}\n\n.online-card {\n  /* border-left: 6px solid #28a745 !important; */\n  background-color: #050A30 !important;\n  animation: pulseOnline 1.5s infinite;\n}\n\n.offline-card {\n  background-color: #1c1f3a !important;\n  opacity: 1;\n  /* border: 1px dashed #888 !important; */\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.status-online {\n  background-color: #00c853;\n  color: #fff;\n}\n\n.status-offline {\n  background-color: #d32f2f;\n  color: #fff;\n}\n\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-size: 0.8rem;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.status-online {\n  background-color: #00c853;\n  color: #fff;\n}\n\n.status-offline {\n  background-color: #d32f2f;\n  color: #fff;\n}\n\n\n@keyframes pulseOnline {\n  0% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(40, 167, 69, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0);\n  }\n}\n\n.offline-info {\n  flex-grow: 1;\n  color: #b0b0b0;\n  padding: 20px 10px;\n}\n\n.offline-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #e57373;\n}\n\n.offline-subtitle {\n  font-size: 0.9rem;\n  font-style: italic;\n  color: #9e9e9e;\n}\n\n.chart-legends {\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  font-size: 0.9rem;\n  cursor: pointer;\n  user-select: none;\n}\n\n.legend-item.hidden {\n  text-decoration: line-through;\n  opacity: 0.5;\n}\n\n.legend-icon {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 6px;\n}\n\n@keyframes rotate {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.animated-icon {\n  display: inline-block;\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes dots {\n  0% { content: \" \"; }\n  33% { content: \".\"; }\n  66% { content: \"..\"; }\n  100% { content: \"...\"; }\n}\n\n.animated-dots::after {\n  content: \"...\";\n  animation: dots 1.5s infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
